import React from "react";
import { IconProps } from "react-feather";

function SidebarButton({
  children,
  icon: Icon,
  elementType: ElementType = "button",
  onClick = () => {},
  isActive,
  className,
}: {
  children: React.ReactNode;
  icon: React.FunctionComponent<IconProps>;
  elementType?: keyof JSX.IntrinsicElements;
  onClick?: () => void;
  isActive: boolean;
  className?: string;
}) {
  return (
    <ElementType
      className={`w-full mb-3 p-1 pr-5 rounded-lg ${
        isActive ? "bg-brand-100" : "hover:bg-slate-200"
      }
          ${className}
        text-left flex items-center font-semibold text-sm cursor-pointer`}
      onClick={onClick}
    >
      <div className={`p-2 rounded mr-3 ${isActive ? "text-brand-800" : ""}`}>
        <Icon size={15} />
      </div>
      {children}
    </ElementType>
  );
}

export default SidebarButton;
